<template>
  <div>
    <div class="title">Nieuwe Data dump uploaden</div>
    <formInput
      class="customInput"
      :model="form"
      modelKey="naam"
      label="on-border"
      placeholder="Interne naam voor datadump"
    />

    <br />

    <b-field
      v-if="selectedFile === null"
      :type="{
        'is-danger': computedValidationMessage(),
      }"
      :message="computedValidationMessage()"
    >
      <b-upload
        @input="validation.extension = null"
        v-model="selectedFile"
        drag-drop
        expanded
        accept=".csv, .ods, .xlsm, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      >
        <section class="section">
          <div class="content has-text-centered">
            <p>
              <b-icon icon="upload" size="is-large"></b-icon>
            </p>
            <p>Sleep bestand hierin, of klik om een bestand te kiezen</p>
          </div>
        </section>
      </b-upload>
    </b-field>
    <span v-else>
      {{ selectedFile.name }}&nbsp;
      <button
        class="button is-danger is-small is-pulled-right"
        @click="selectedFile = null"
      >
        Annuleren
      </button>
    </span>
    <br />
    <span class="help is-danger" v-if="validation.extension">{{
      validation.extension[0]
    }}</span>
    <br />
    <br />
    <button
      :class="{ 'is-loading': ajaxloading.uploading_data_dump }"
      class="button is-primary is-fullwidth"
      @click="upload()"
    >
      Uploaden
    </button>

    <br />
    <button
      :class="{ 'is-loading': ajaxloading.uploading_data_dump }"
      class="button is-danger is-fullwidth"
      @click="cancelUpdate()"
    >
      Annuleren
    </button>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      form: {},
      selectedFile: null,
    };
  },
  computed: {},
  methods: {
    computedValidationMessage() {
      if (this.validation.file) {
        return this.validation.file;
      }
    },
    upload() {
      const formData = new FormData();
      if (this.selectedFile) {
        formData.append("file", this.selectedFile);
      }

      if (this.form.naam) {
        formData.append("naam", this.form.naam);
      }
      this.$store.dispatch("uploads/uploadDatadump", formData).then(() => {
        // this.$store.dispatch("createFlashBanner", "Datadump geupload.");
        this.$buefy.dialog.alert(
          "Datadump wordt momenteel verwerkt. U krijgt een email wanneer deze gereed is."
        );
        this.$router.go(-1);
      });
    },
  },
  mounted() {},
};
</script>
